import { SearchState } from '../types';

const clearSearchFiltersReducer = (state: SearchState) => {
  state.settings.filters = {};

  // remove checked from filters
  state.filters.forEach((f) => {
    f.facets.forEach((facet) => {
      facet.checked = false;
    });
  });
};

export default clearSearchFiltersReducer;
